<template>
    <!-- prettier-ignore -->
    <div class="flex h-full flex-col overflow-hidden bg-white">
        <div class="flex items-center justify-between px-8 py-4" style="background-color: #E2E8F0;">
            <div class="flex items-center text-base font-medium text-black">
                Subscription
            </div>
            <div class="cursor-pointer text-slate-500 transition hover:text-slate-700" @click="$emit('close')">
                <Icon icon-name="CloseIcon" />
            </div>
        </div>

        <div class="flex-1 space-y-6 bg-white px-8 py-6 mt-4">
            <div class="relative border border-slate-200 bg-white p-6 rounded-md">
                <div
                    class="absolute badge-dot inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
                    <span>{{ title }}</span>
                </div>
                <div class="space-y-4 text-sm text-slate-600">
                    <div class="flex items-center gap-3">
                        <span class="subscription-icon bg-blue-50 text-blue-500">
                            <Icon icon-name="Subscription" />
                        </span>
                        <div>
                            <p class="text-sm font-semibold text-slate-800">
                                {{ plan.name }}
                            </p>
                            <p class="text-xs text-slate-500">
                                {{ plan.billingCycle }}
                            </p>
                        </div>
                    </div>

                    <div class="flex items-center gap-3">
                        <span class="subscription-icon bg-green-50 text-green-600">
                            <Icon icon-name="Connector" />
                        </span>
                        <div :class="['flex items-center gap-2 rounded-lg px-3 py-1', status.background]">
                            <span :class="['status-dot', status.dot]"></span>
                            <span :class="['text-sm font-semibold capitalize', status.text]">
                                {{ status.label }}
                            </span>
                        </div>
                    </div>

                    <div class="flex items-center gap-3">
                        <span class="subscription-icon bg-slate-100 text-slate-600">
                            <Icon icon-name="CalendarIcon" class="h-4 w-4" />
                        </span>
                        <div class="flex flex-col">
                            <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">
                                {{ nextBilling.label }}
                            </span>
                            <span class="text-sm text-slate-700">
                                {{ nextBilling.date }}
                            </span>
                            <span v-if="nextBilling.amount" class="text-xs text-slate-500">
                                {{ nextBilling.amount }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rounded-md border border-slate-200 bg-white p-6 relative">
                <div
                    class="absolute badge-dot inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
                    <span>Logs</span>
                </div>
                <div class="space-y-6">
                    <p v-if="!logs || logs.length === 0" class="text-sm text-slate-500 text-center py-4">
                        No logs found
                    </p>
                    <div v-for="(log, index) in logs" :key="index" class="flex items-start gap-4">
                        <div
                            :class="[
                                'timeline-marker flex flex-col items-center',
                                {
                                    'timeline-marker--first': index === 0,
                                    'timeline-marker--last': index === logs.length - 1
                                }
                            ]"
                        >
                            <span class="inline-flex h-3 w-3 rounded-full bg-blue-500"></span>
                        </div>
                        <div class="space-y-1 text-sm">
                            <div class="font-semibold text-slate-800">{{ log.date }}</div>
                            <div class="text-slate-600">{{ log.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../core/Icon.vue";

export default {
    name: "SubscriptionDrawerContent",
    components: {
        Icon
    },
    props: {
        title: {
            type: String,
            default: "Subscription Detail"
        },
        plan: {
            type: Object,
            default: () => ({ name: "-", billingCycle: "-" })
        },
        status: {
            type: Object,
            default: () => ({ label: "-", background: "bg-slate-100", text: "text-slate-600", dot: "bg-slate-400" })
        },
        nextBilling: {
            type: Object,
            default: () => ({ label: "Next Billing Date", date: "-", amount: "" })
        },
        logs: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style scoped>
.badge-dot {
    top: -16px;
    border-radius: 3px;
}

.subscription-icon {
    @apply inline-flex h-10 w-10 items-center justify-center rounded-lg text-base font-semibold;
}

.status-dot {
    @apply inline-flex h-2 w-2 rounded-full;
}

.timeline-marker {
    position: relative;
}

.timeline-marker::after {
    content: "";
    position: absolute;
    top: 0.75rem;
    bottom: -1.5rem;
    left: 50%;
    width: 1px;
    transform: translateX(-50%);
    background: #e2e8f0;
}

.timeline-marker::before {
    content: "";
    position: absolute;
    top: -1.5rem;
    bottom: 0.75rem;
    left: 50%;
    width: 1px;
    transform: translateX(-50%);
    background: #e2e8f0;
}

.timeline-marker--first::before {
    display: none;
}

.timeline-marker--last::after {
    display: none;
}
</style>
